/**
 * Maps Contentful SectionPanel `appearance` (short text / enum label) to a stable BEM modifier on
 * `.section-panel-*` roots so CSS can target variants without brittle string matching in JSX.
 *
 * @param {string|undefined|null} appearance
 * @returns {string|undefined} e.g. `section-panel--appearance-editorial-feature-block-cf-020-1`
 */
export const sectionPanelAppearanceClass = (appearance) => {
  if (appearance == null || appearance === '') return undefined;

  const slug = String(appearance)
    .toLowerCase()
    .replace(/[\[\]()]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (!slug) return undefined;

  return `section-panel--appearance-${slug}`;
};
